const styles = theme => ({
  span: {
    display: 'flex',
    flex: '1 1 auto',
    alignItems: 'center',
  },
  darkGrey: { color: 'rgba(0, 0, 0, 0.54)' },
  root: {
    width: '100%',
    maxWidth: 800,
    backgroundColor: 'transparent',
    // marginTop: '8px',
  },
  meal: {
    display: 'flex',
    flex: '1 1 auto',
    alignSelf: 'center',
    height: '100%',
    fontSize: '13.5px',
    fontWeight: 'bold',
    textTransform: 'capitalize',
  },
  ml5: { marginLeft: 5 },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/meals/selectedMealListItem/SelectedMealListItemStyles.js